var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 12C24 18.6274 18.6274 24 12 24C5.37555 23.9927 0.00717163 18.6245 0 12C0 5.37256 5.37259 0 12 0C18.6274 0 24 5.37256 24 12ZM16.225 13.3237C16.5646 13.187 16.7937 12.8657 16.812 12.5C16.7941 12.1338 16.5649 11.812 16.225 11.6748L10.14 8.63184C9.82668 8.44043 9.43242 8.44189 9.12021 8.63477C8.80798 8.82812 8.63084 9.18018 8.662 9.5459V15.4521C8.64374 15.8154 8.81813 16.1616 9.121 16.3628C9.26772 16.4531 9.43681 16.5 9.60901 16.499C9.79396 16.4966 9.97581 16.4512 10.14 16.3657L16.225 13.3237Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlay);
export default __webpack_public_path__ + "static/media/play.50c1b8bd.svg";
export { ForwardRef as ReactComponent };